module.exports = __webpack_public_path__ + "static/media/logo-salud-filled.c6dd0d2e.svg";